import getActiveSurfaceViewPath from '../utils/getActiveSurfaceViewPath';
import { getCalendarPath } from 'owa-url';
import { getHostLocation } from 'owa-url/lib/hostLocation';
import { orchestrator } from 'satcheljs';
import { timeZoneChanged } from 'mini-options-store/lib/actions/timeZone/timeZoneChanged';

export const reloadActiveSurfaceOrchestrator = orchestrator(timeZoneChanged, () => {
    location.assign(
        getCalendarPath() + getActiveSurfaceViewPath() + '/' + getHostLocation().search
    );
});
